import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WarehouseActivityAttributes, WarehouseAttributes } from '../../types/apiType';

interface SaveDialogState {
  open: boolean;
  data?: WarehouseAttributes;
}

interface SaveActivityDialogState {
  open: boolean;
  data?: WarehouseActivityAttributes;
}

export interface WarehouseState {
  saveDialog: SaveDialogState;
  activityDialog: SaveActivityDialogState;
}

const initialState: WarehouseState = {
  saveDialog: {
    open: false,
  },
  activityDialog: {
    open: false,
  },
};

export const warehouseSlice = createSlice({
  name: 'warehouse',
  initialState,
  reducers: {
    setSaveWarehouseModal: (state, action: PayloadAction<SaveDialogState>) => {
      state.saveDialog = action.payload;
    },
    setSaveActivityDialog: (state, action: PayloadAction<SaveActivityDialogState>) => {
      state.activityDialog = action.payload;
    },
  },
});

export const { setSaveWarehouseModal, setSaveActivityDialog } = warehouseSlice.actions;

export default warehouseSlice.reducer;
